<template>
  <section
    id="dashboard_main_arae"
    class="section_padding section_padding--mini"
  >
    <div class="container">
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="pills-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#pills-home"
            type="button"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
          >
            Clientes
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="titulos-tab"
            data-bs-toggle="tab"
            data-bs-target="#titulos"
            type="button"
            role="tab"
            aria-controls="titulos"
            aria-selected="false"
          >
            Titulos
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="convites-tab"
            data-bs-toggle="tab"
            data-bs-target="#convites"
            type="button"
            role="tab"
            aria-controls="convites"
            aria-selected="false"
          >
            Convites
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="comodidades-tab"
            data-bs-toggle="tab"
            data-bs-target="#comodidades"
            type="button"
            role="tab"
            aria-controls="comodidades"
            aria-selected="false"
          >
            Comodidades
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="hp-tab"
            data-bs-toggle="tab"
            data-bs-target="#hp"
            type="button"
            role="tab"
            aria-controls="hp"
            aria-selected="false"
          >
            Hoteis e Pousadas
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="pc-tab"
            data-bs-toggle="tab"
            data-bs-target="#pc"
            type="button"
            role="tab"
            aria-controls="pc"
            aria-selected="false"
          >
            Parques e clubes
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="cupons-tab"
            data-bs-toggle="tab"
            data-bs-target="#cupons"
            type="button"
            role="tab"
            aria-controls="cupons"
            aria-selected="false"
          >
            Cupons
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="depoimentos-tab"
            data-bs-toggle="tab"
            data-bs-target="#depoimentos"
            type="button"
            role="tab"
            aria-controls="depoimentos"
            aria-selected="false"
          >
            Depoimentos
          </button>
        </li>
      </ul>

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <form
            @submit.prevent="listProfiles(email, code)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-md-5">
              <input
                type="email"
                v-model="email"
                class="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="Buscar por e-mail"
              />
            </div>
            <div class="col-md-5">
              <input
                type="text"
                v-model="code"
                class="form-control form-control-sm"
                id="exampleFormControlInput2"
                placeholder="Buscar por código"
              />
            </div>
            <div class="col-md-2">
              <button type="submit" class="btn btn-primary w-100">Buscar</button>
            </div>
          </form>

          <div class="row">
            <template v-for="profile in profiles" :key="profile?.indentify">
              <div class="col-md-4 mb-3">
                <div class="card">
                  <div class="card-body position-relative">
                    <h5 class="card-title">{{ profile?.name }}</h5>
                    <p class="card-text">{{ profile.email }}</p>

                    <div
                      class="expand-contanct cursor-pointer link"
                      data-bs-toggle="modal"
                      data-bs-target="#modalContact"
                      @click="
                        (profileDetails = profile),
                          getReservations(profile, profile.reservations)
                      "
                    >
                      <i class="far fa-eye"></i>
                    </div>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Telefone: {{ profile?.phone }}
                    </li>
                    <li class="list-group-item" :class="profile?.plan">
                      Código: {{ profile.plan_indentify || "Free" }}
                    </li>
                    <li class="list-group-item">
                      Tipo para contato:
                      {{ profile?.contactPreference || "Todos" }}
                    </li>
                    <li class="list-group-item">
                      Titular:
                      {{
                        profile?.dep && profile?.plan_indentify
                          ? "Não"
                          : "Sim" || "Sem Título"
                      }}
                    </li>
                  </ul>
                  <div class="card-body">
                    <div class="d-block" v-if="!profile?.dep">
                      <input
                        v-model="profile.tt"
                        @keypress.enter="addTitle(profile.tt, profile)"
                        placeholder="Adicionar título"
                        class="px-2"
                      />
                      <div v-if="msgErrorTitle == profile.indentify">
                        <span class="text-danger">
                          Código do título não existe ou está em uso
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="titulos"
          role="tabpanel"
          aria-labelledby="titulos-tab"
        >
          <form
            @submit.prevent="listTitles(title)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-9">
              <input
                type="text"
                v-model="title"
                class="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="Buscar por titulo"
              />
            </div>
            <div class="col-auto">
              <button type="submit" class="btn btn-primary">Buscar</button>
            </div>
            <div class="col-auto">
              <select
                v-model="type"
                @change="listTitles(null, type)"
                class="form-select"
                aria-label="Planos"
              >
                <option value="ouro">Ouro</option>
                <option value="prata">Prata</option>
                <option value="bronze">Bronze</option>
                <option value="uso">Em Uso</option>
                <option value="sem_uso">Sem Uso</option>
              </select>
            </div>
            <div class="d-flex justify-content-end">
              <btn
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal8"
              >
                Adicionar
              </btn>
            </div>
          </form>

          <div class="row">
            <template v-for="title in titles" :key="title?.plan_indentify">
              <div class="col-md-4 mb-3">
                <div class="card">
                  <div class="form-check mx-2 my-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      @change="setUso(title)"
                      v-model="title.uso"
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Em uso
                    </label>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Código: {{ title.plan_indentify }}
                    </li>
                    <li class="list-group-item">Título: {{ title.plan }}</li>
                    <li class="list-group-item">
                      Desbloqueado
                      {{ title?.unlocked ? "Sim" : "Não" }}
                    </li>
                    <li class="list-group-item">
                      Válido: {{ title?.validy ? "Sim" : "Não" }}
                    </li>
                  </ul>
                  <div class="card-body" v-if="!title?.unlocked">
                    <button
                      class="btn btn-success btn-sm mt-2 float-end"
                      @click="unlocked(title, true)"
                    >
                      Desbloquear
                    </button>
                    <button
                      class="btn btn-danger btn-sm mt-2 float-end"
                      style="margin-right: 0.5rem; display: inline-block"
                      @click="_deleteTitle(title.plan_indentify)"
                    >
                      Deletar
                    </button>
                  </div>
                  <div class="card-body" v-else>
                    <button
                      class="btn btn-danger btn-sm mt-2 float-end"
                      @click="unlocked(title, false)"
                    >
                      Bloquear
                    </button>
                  </div>
                </div>
              </div>
            </template>

            <span v-if="!titles.length" class="py-4">
              Não encontramos título
            </span>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="convites"
          role="tabpanel"
          aria-labelledby="convites-tab"
        >
          <form
            @submit.prevent="listInvite(invite)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-11">
              <input
                type="text"
                v-model="invite"
                class="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="Buscar por titulo"
              />
            </div>
            <div class="col-auto">
              <button type="submit" class="btn btn-primary">Buscar</button>
            </div>
            <div class="d-flex justify-content-end">
              <btn
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal9"
              >
                Adicionar
              </btn>
            </div>
          </form>

          <div class="row">
            <template v-for="invite in invites" :key="invite?.plan_indentify">
              <div class="col-md-4 mb-3" v-if="invite.validy">
                <div class="card">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Código: {{ invite.plan_indentify }}
                    </li>
                    <li class="list-group-item">Plano: {{ invite.plan }}</li>
                    <li class="list-group-item">Título: Convidado</li>
                    <li class="list-group-item">
                      Valido: {{ invite?.validy ? "Sim" : "Não" }}
                    </li>
                  </ul>
                  <div class="col-md-12">
                    <button
                      class="btn btn-danger btn-sm my-2 float-end"
                      style="margin-right: 0.5rem; display: inline-block"
                      @click="_deleteInvite(invite.plan_indentify)"
                    >
                      Deletar
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <span v-if="!invites.length" class="py-4">
              Não encontramos cupom de convite
            </span>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="comodidades"
          role="tabpanel"
          aria-labelledby="comodidades-tab"
        >
          <form
            @submit.prevent="listInvite(invite)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-10">
              <!-- <input type="text" v-model="invite" class="form-control form-control-sm" id="exampleFormControlInput1" placeholder="Buscar por titulo"> -->
            </div>
            <div class="col-2">
              <button
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal2"
                @click="hotelEdit = null"
              >
                Adicionar
              </button>
            </div>
          </form>

          <div class="row">
            <template v-for="hotel in hotels" :key="hotel?.plan_indentify">
              <div
                v-if="
                  hotel?.category == 'Apartamento' || hotel?.category == 'Casa'
                "
                class="col-md-4 mb-3"
              >
                <div class="card">
                  <img :src="hotel?.photos[0]" class="card-img-top" />
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Categoria: {{ hotel.category }}
                    </li>
                    <li class="list-group-item">Nome: {{ hotel.name }}</li>
                    <li class="list-group-item">
                      ativo: {{ hotel?.disabled ? "Não" : "Sim" }}
                    </li>
                    <li class="list-group-item">
                      Cidade: {{ hotel?.city }}{{ hotel?.state ? ' - ' + hotel.state.toUpperCase() : '' }}
                    </li>
                    <li class="list-group-item">
                      Bairro: {{ hotel?.neighborhood }}
                    </li>
                    <li class="list-group-item" v-if="hotel?.state">
                      Estado: {{ hotel.state.toUpperCase() }}
                    </li>
                    <li class="list-group-item">
                      Localização: {{ hotel?.location }}
                    </li>
                    <li class="list-group-item">
                      N de pessoas: {{ hotel?.person }}
                    </li>

                    <li class="list-group-item">Plano: {{ hotel?.plan }}</li>
                    <li class="list-group-item" v-if="hotel.price">
                      Preço:
                      {{
                        hotel?.price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.member_price">
                      Preço para sócios:
                      {{
                        hotel?.member_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.high_season_price">
                      Preço alta temporada:
                      {{
                        hotel?.high_season_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-outline-danger btn-sm btn-outline mt-2"
                        @click="deleteHotel(hotel.indentify)"
                      >
                        Deletar
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-outline-primary btn-sm btn-outline mt-2"
                        data-bs-toggle="modal"
                        data-bs-target="#modal2"
                        @click="editHotel(hotel)"
                      >
                        Editar
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <span
              v-if="
                (!hotels.length && hotel?.category == 'Apartamento') ||
                (!hotels.length && hotel?.category == 'Casa')
              "
              class="py-4"
            >
              Não encontramos cupom de hoteis
            </span>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="hp"
          role="tabpanel"
          aria-labelledby="hp-tab"
        >
          <form
            @submit.prevent="listInvite(invite)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-10">
              <!-- <input type="text" v-model="invite" class="form-control form-control-sm" id="exampleFormControlInput1" placeholder="Buscar por titulo"> -->
            </div>
            <div class="col-2">
              <button
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal4"
                @click="hotelEdit = null"
              >
                Adicionar
              </button>
            </div>
          </form>

          <div class="row">
            <template v-for="hotel in hotels" :key="hotel?.plan_indentify">
              <div
                v-if="
                  hotel?.category == 'Hotel' || hotel?.category == 'Pousada'
                "
                class="col-md-4 mb-3"
              >
                <div class="card">
                  <img :src="hotel?.photos[0]" class="card-img-top" />
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Categoria: {{ hotel.category }}
                    </li>
                    <li class="list-group-item">
                      Link de Campanha: <br />
                      {{ hotel?.campLink }}
                    </li>
                    <li class="list-group-item">Nome: {{ hotel.name }}</li>
                    <li class="list-group-item">
                      ativo: {{ hotel?.disabled ? "Não" : "Sim" }}
                    </li>
                    <li class="list-group-item">
                      Cidade: {{ hotel?.city }}{{ hotel?.state ? ' - ' + hotel.state.toUpperCase() : '' }}
                    </li>
                    <li class="list-group-item">
                      Bairro: {{ hotel?.neighborhood }}
                    </li>
                    <li class="list-group-item" v-if="hotel?.state">
                      Estado: {{ hotel.state.toUpperCase() }}
                    </li>
                    <li class="list-group-item">
                      Localização: {{ hotel?.location }}
                    </li>
                    <li class="list-group-item">
                      N de pessoas: {{ hotel?.person }}
                    </li>

                    <li class="list-group-item">Plano: {{ hotel?.plan }}</li>
                    <li class="list-group-item" v-if="hotel.price">
                      Preço:
                      {{
                        hotel?.price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.member_price">
                      Preço para sócios:
                      {{
                        hotel?.member_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.high_season_price">
                      Preço alta temporada:
                      {{
                        hotel?.high_season_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-outline-danger btn-sm btn-outline mt-2"
                        @click="deleteHotel(hotel.indentify)"
                      >
                        Deletar
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-outline-primary btn-sm btn-outline mt-2"
                        data-bs-toggle="modal"
                        data-bs-target="#modal4"
                        @click="editHp(hotel)"
                      >
                        Editar
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <span
              v-if="
                (!hotels.length && hotel?.category == 'Hotel') ||
                (!hotels.length && hotel?.category == 'Pousada')
              "
              class="py-4"
            >
              Não encontramos cupom de hoteis
            </span>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="pc"
          role="tabpanel"
          aria-labelledby="pc-tab"
        >
          <form
            @submit.prevent="listInvite(invite)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-10">
              <!-- <input type="text" v-model="invite" class="form-control form-control-sm" id="exampleFormControlInput1" placeholder="Buscar por titulo"> -->
            </div>
            <div class="col-2">
              <button
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal5"
                @click="hotelEdit = null"
              >
                Adicionar
              </button>
            </div>
          </form>

          <div class="row">
            <template v-for="hotel in hotels" :key="hotel?.plan_indentify">
              <div
                v-if="hotel?.category == 'Parque' || hotel?.category == 'Clube'"
                class="col-md-4 mb-3"
              >
                <div class="card">
                  <img :src="hotel?.photos[0]" class="card-img-top" />
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Categoria: {{ hotel.category }}
                    </li>
                    <li class="list-group-item">
                      Link de Campanha: <br />
                      {{ hotel?.campLink }}
                    </li>
                    <li class="list-group-item">Nome: {{ hotel.name }}</li>
                    <li class="list-group-item">
                      ativo: {{ hotel?.disabled ? "Não" : "Sim" }}
                    </li>
                    <li class="list-group-item">
                      Cidade: {{ hotel?.city }}{{ hotel?.state ? ' - ' + hotel.state.toUpperCase() : '' }}
                    </li>
                    <li class="list-group-item">
                      Bairro: {{ hotel?.neighborhood }}
                    </li>
                    <li class="list-group-item" v-if="hotel?.state">
                      Estado: {{ hotel.state.toUpperCase() }}
                    </li>
                    <li class="list-group-item">
                      Localização: {{ hotel?.location }}
                    </li>
                    <li class="list-group-item">
                      N de pessoas: {{ hotel?.person }}
                    </li>

                    <li class="list-group-item">Plano: {{ hotel?.plan }}</li>
                    <li class="list-group-item" v-if="hotel.price">
                      Preço:
                      {{
                        hotel?.price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.member_price">
                      Preço para sócios:
                      {{
                        hotel?.member_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item" v-if="hotel.high_season_price">
                      Preço alta temporada:
                      {{
                        hotel?.high_season_price.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-outline-danger btn-sm btn-outline mt-2"
                        @click="deleteHotel(hotel.indentify)"
                      >
                        Deletar
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-outline-primary btn-sm btn-outline mt-2"
                        data-bs-toggle="modal"
                        data-bs-target="#modal5"
                        @click="editPc(hotel)"
                      >
                        Editar
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <span
              v-if="
                (!hotels.length && hotel?.category == 'Hotel') ||
                (!hotels.length && hotel?.category == 'Pousada')
              "
              class="py-4"
            >
              Não encontramos cupom de hoteis
            </span>
          </div>
        </div>

        <!-- Cupons -->
        <div
          class="tab-pane fade show"
          id="cupons"
          role="tabpanel"
          aria-labelledby="cupons-tab"
        >
          <form
            @submit.prevent="listInvite(invite)"
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-10">
              <!-- <input type="text" v-model="invite" class="form-control form-control-sm" id="exampleFormControlInput1" placeholder="Buscar por titulo"> -->
            </div>
            <div class="col-2">
              <button
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modal3"
                @click="cupomEdit = null"
              >
                Adicionar
              </button>
            </div>
          </form>

          <div class="row">
            <template
              v-for="cupom in cupons.sort((a, b) => {
                return a.enabled === b.enabled ? 0 : a.enabled ? -1 : 1;
              })"
              :key="cupom?.indentify"
            >
              <div class="col-md-4 mb-3">
                <div class="card">
                  <img
                    v-if="cupom?.photos?.length"
                    :src="cupom?.photos[0]"
                    class="card-img-top"
                  />
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">Nome: {{ cupom.name }}</li>
                    <li class="list-group-item">
                      ativo: {{ cupom?.enabled ? "Sim" : "Não" }}
                    </li>
                    <li class="list-group-item">
                      Link da campanha: {{ cupom?.campBannerLink }}
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-outline-danger btn-sm btn-outline mt-2"
                        @click="deleteCupom(cupom.indentify)"
                      >
                        Deletar
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-outline-primary btn-sm btn-outline mt-2"
                        data-bs-toggle="modal"
                        data-bs-target="#modal3"
                        @click="editCupom(cupom)"
                      >
                        Editar
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <span v-if="!hotels.length" class="py-4">
              Não encontramos cupom de hoteis
            </span>
          </div>
        </div>

        <!-- Depoimentos -->
        <div
          class="tab-pane fade show"
          id="depoimentos"
          role="tabpanel"
          aria-labelledby="depoimentos-tab"
        >
          <form
            class="row justify-content-between items-center align-items-center g-3 mb-3"
          >
            <div class="col-10"></div>
            <div class="col-2">
              <button
                class="btn btn-outline-primary btn-sm btn-outline mt-2"
                data-bs-toggle="modal"
                data-bs-target="#modalDepoimento"
                @click.prevent="openDepoimentoModal"
              >
                Adicionar
              </button>
            </div>
          </form>

          <div class="row">
            <template
              v-for="depoimento in depoimentos"
              :key="depoimento?.indentify"
            >
              <div class="col-md-4 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{ depoimento.name }}</h5>
                    <p class="card-text">{{ depoimento.description }}</p>
                    <div
                      v-if="depoimento.video_type === 'youtube'"
                      class="ratio ratio-16x9 mb-3"
                    >
                      <iframe
                        :src="
                          'https://www.youtube.com/embed/' + depoimento.video_id
                        "
                        title="YouTube video"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <div
                      v-else-if="depoimento.video_type === 'upload'"
                      class="ratio ratio-16x9 mb-3"
                    >
                      <video controls>
                        <source :src="depoimento.video_url" type="video/mp4" />
                        Seu navegador não suporta o elemento de vídeo.
                      </video>
                    </div>
                    <button
                      class="btn btn-outline-danger btn-sm mt-2"
                      @click="deleteDepoimento(depoimento.id)"
                    >
                      Deletar
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <span v-if="!depoimentos.length" class="py-4">
              Não encontramos depoimentos
            </span>
          </div>
        </div>

        <!-- Modal -->

        <div
          class="modal fade"
          ref="modalRefTitle"
          id="modal8"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Criar Título</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="container modal-body">
                        <div class="row justify-content-center">
                          <div class="col-lg-12">
                            <div class="vendor_form">
                              <div>
                                <form
                                  @submit.prevent="createTitle()"
                                  enctype="multipart/form-data"
                                >
                                  <div class="row g-2 mx-2">
                                    <div class="col-lg-12">
                                      <div
                                        class="form-group has-valindentifyation"
                                      >
                                        <label for="f-name">Cod.</label>
                                        <input
                                          autocomplete="off"
                                          v-model="formDataTitle.plan_indentify"
                                          type="text"
                                          class="form-control"
                                          placeholder="Cod."
                                        />
                                      </div>
                                    </div>

                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="f-plano">Plano</label>
                                        <select
                                          v-model="formDataTitle.plan"
                                          class="form-control form-select"
                                        >
                                          <option selected value="ouro">
                                            Ouro
                                          </option>
                                          <option value="prata">Prata</option>
                                          <option value="bronze">Bronze</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="f-plano"
                                          >Desbloqueado</label
                                        >
                                        <select
                                          v-model="formDataTitle.unlocked"
                                          class="form-control form-select"
                                        >
                                          <option selected :value="true">
                                            Sim
                                          </option>
                                          <option :value="false">Não</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="f-plano">Em uso</label>
                                        <select
                                          v-model="formDataTitle.uso"
                                          class="form-control form-select"
                                        >
                                          <option :value="true">Sim</option>
                                          <option selected :value="false">
                                            Não
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="modal-footer mt-4">
                                    <button
                                      type="button"
                                      class="btn btn-secondary"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancelar
                                    </button>
                                    <button
                                      type="submit"
                                      class="btn btn-primary"
                                    >
                                      Adicionar
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalRefInvite"
          id="modal9"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Criar Convite
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="container modal-body">
                        <div class="row justify-content-center">
                          <div class="col-lg-12">
                            <div class="vendor_form">
                              <div>
                                <form
                                  @submit.prevent="createInvite()"
                                  enctype="multipart/form-data"
                                >
                                  <div class="row g-2 mx-2">
                                    <div class="col-lg-12">
                                      <div
                                        class="form-group has-valindentifyation"
                                      >
                                        <label for="f-name">Cod.</label>
                                        <input
                                          autocomplete="off"
                                          v-model="
                                            formDataInvite.plan_indentify
                                          "
                                          type="text"
                                          class="form-control"
                                          placeholder="Cod."
                                        />
                                      </div>
                                    </div>

                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="f-plano">Plano</label>
                                        <select
                                          v-model="formDataInvite.plan"
                                          class="form-control form-select"
                                        >
                                          <option selected value="ouro">
                                            Ouro
                                          </option>
                                          <option value="prata">Prata</option>
                                          <option value="bronze">Bronze</option>
                                        </select>
                                      </div>
                                    </div>
                                    <p>
                                      O convite criado tem duração de 3 meses e
                                      uso único.
                                    </p>
                                  </div>
                                  <div class="modal-footer mt-4">
                                    <button
                                      type="button"
                                      class="btn btn-secondary"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancelar
                                    </button>
                                    <button
                                      type="submit"
                                      class="btn btn-primary"
                                    >
                                      Adicionar
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalRef"
          id="modal2"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Comodidade</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <AddHotel
                        @setHotel="setHotel($event)"
                        @closed="closed()"
                        :dependent="hotelEdit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalRefHp"
          id="modal4"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Hotéis e Pousadas
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <addParkTour
                        @setHotel="setHp($event)"
                        @closed="closed('hp')"
                        :dependent="hpEdit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalRefPc"
          id="modal5"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Parques e clubes
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <AddParkClub
                        @setHotel="setPc($event)"
                        @closed="closed('pc')"
                        :dependent="pcEdit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalRefCupom"
          id="modal3"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Cupom</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                      <AddCupons
                        @setCupom="setCupom($event)"
                        @closed="closed('cupom')"
                        :dependent="cupomEdit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          ref="modalContact"
          id="modalContact"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {{ editingProfile ? 'Editar Cliente' : 'Cliente' }}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="editingProfile = false; editingDependent = null"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="d-flex justify-content-end mb-3">
                    <button
                      v-if="!editingProfile"
                      type="button"
                      class="btn btn-primary"
                      @click="editingProfile = true"
                    >
                      <i class="fas fa-edit"></i> Editar Cliente
                    </button>
                    <div v-else>
                      <button
                        type="button"
                        class="btn btn-success me-2"
                        @click="saveProfileEdit"
                      >
                        <i class="fas fa-save"></i> Salvar
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="editingProfile = false; profileDetails = { ..._profile }"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-lg-6 my-1">
                      <label>Nome:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.name"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.name }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>E-mail:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.email"
                        type="email"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.email }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>CPF:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.cpf"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.cpf }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>RG:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.rg"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.rg }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Parentesco:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.kinship"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.kinship }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Telefone:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.phone"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.phone }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Sexo:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.sex"
                        class="form-control form-select form-select-sm"
                      >
                        <option value="Masculino">Masculino</option>
                        <option value="Feminino">Feminino</option>
                        <option value="Outro">Outro</option>
                      </select>
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.sex }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Data de Nascimento:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.date_birth"
                        type="date"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.date_birth }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Senha:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.password"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.password }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Tipo para contato:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.contactPreference"
                        class="form-control form-select form-select-sm"
                      >
                        <option value="Todos">Todos</option>
                        <option value="Whatsapp">Whatsapp</option>
                        <option value="Email">Email</option>
                        <option value="Telefone">Telefone</option>
                        <option value="nenhum">Nenhum</option>
                      </select>
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.contactPreference || 'Todos' }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Data de Criação:</label>
                      <small class="text-body-secondary d-block">
                        {{
                          profileDetails?.date_created?.seconds
                            ? new Date(profileDetails.date_created.seconds * 1000).toLocaleString('pt-BR')
                            : profileDetails?.date_created
                            ? new Date(profileDetails.date_created).toLocaleString('pt-BR')
                            : 'Não informado'
                        }}
                      </small>
                    </div>

                    <h3 class="d-block my-3">Informações do Plano</h3>

                    <div class="col-md-6 my-1">
                      <label>Plano:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.plan"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="d-block">
                        <span :class="profileDetails?.plan" class="badge bg-primary text-white">
                          {{ profileDetails?.plan || 'Free' }}
                        </span>
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Código do Plano:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.plan_indentify"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="d-block text-white">
                        <strong>{{ profileDetails?.plan_indentify || 'Free' }}</strong>
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Plano Desbloqueado:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.plan_unlocked"
                        class="form-control form-select form-select-sm"
                      >
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                      <small v-else class="d-block text-white">
                        <span :class="profileDetails?.plan_unlocked ? 'text-success' : 'text-danger'">
                          <i :class="profileDetails?.plan_unlocked ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                          {{ profileDetails?.plan_unlocked ? 'Sim' : 'Não' }}
                        </span>
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Plano Válido:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.plan_valid"
                        class="form-control form-select form-select-sm"
                      >
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                      <small v-else class="d-block text-white">
                        <span :class="profileDetails?.plan_valid ? 'text-success' : 'text-danger'">
                          <i :class="profileDetails?.plan_valid ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                          {{ profileDetails?.plan_valid ? 'Sim' : 'Não' }}
                        </span>
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Titular:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.dep"
                        class="form-control form-select form-select-sm"
                      >
                        <option :value="false">Sim (Titular)</option>
                        <option :value="true">Não (Dependente)</option>
                      </select>
                      <small v-else class="d-block text-white">
                        <span :class="profileDetails?.dep ? 'text-warning' : 'text-success'">
                          <i :class="profileDetails?.dep ? 'fas fa-user-friends' : 'fas fa-user-tie'"></i>
                          {{ profileDetails?.dep ? 'Não (Dependente)' : 'Sim (Titular)' }}
                        </span>
                      </small>
                    </div>
                    <div class="col-md-6 my-1" v-if="profileDetails?.admin !== undefined">
                      <label>Administrador:</label>
                      <select
                        v-if="editingProfile"
                        v-model="profileDetails.admin"
                        class="form-control form-select form-select-sm"
                      >
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                      <small v-else class="d-block text-white">
                        <span :class="profileDetails?.admin ? 'text-danger' : 'text-secondary'">
                          <i :class="profileDetails?.admin ? 'fas fa-shield-alt' : 'fas fa-user'"></i>
                          {{ profileDetails?.admin ? 'Sim' : 'Não' }}
                        </span>
                      </small>
                    </div>

                    <h3 class="d-block my-3">Endereço</h3>

                    <div class="col-md-6 my-1">
                      <label>CEP:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.cep"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.cep }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Cidade:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.cidade"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.cidade }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Bairro:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.bairro"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.bairro }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Endereço:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.logradouro"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.logradouro }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>Número:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.numero"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.numero }}
                      </small>
                    </div>
                    <div class="col-md-6 my-1">
                      <label>UF:</label>
                      <input
                        v-if="editingProfile"
                        v-model="profileDetails.uf"
                        type="text"
                        class="form-control form-control-sm"
                      />
                      <small v-else class="text-body-secondary d-block">
                        {{ profileDetails?.uf }}
                      </small>
                    </div>

                    <h3 class="mt-4 mb-3">Dependentes</h3>
                    
                    <div v-if="clientDependents.length > 0" class="col-lg-12 mb-3">
                      <div class="table-responsive">
                        <table class="table table-sm table-striped">
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>E-mail</th>
                              <th>CPF</th>
                              <th>Telefone</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="dep in clientDependents" :key="dep.indentify">
                              <td>{{ dep.name }}</td>
                              <td>{{ dep.email }}</td>
                              <td>{{ dep.cpf }}</td>
                              <td>{{ dep.phone }}</td>
                              <td>
                                <button
                                  class="btn btn-sm btn-primary me-1"
                                  @click="editDependent(dep)"
                                  data-bs-toggle="modal"
                                  data-bs-target="#modalEditDependent"
                                >
                                  <i class="fas fa-edit"></i>
                                </button>
                                <button
                                  class="btn btn-sm btn-danger"
                                  @click="deleteClientDependent(dep)"
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else class="col-lg-12 mb-3">
                      <p class="text-muted">Nenhum dependente encontrado.</p>
                    </div>

                    <h3 class="mt-3">Reservas</h3>

                    <div class="col-lg-12">
                      <div class="dashboard_common_table">
                        <div class="table-responsive-lg table_common_area">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th class="text-center">ID</th>
                                <th></th>
                                <th>Entrada</th>
                                <th>Saída</th>
                                <th>diárias | hóspedes</th>
                                <th>Status</th>
                                <th class="text-end">Pagamento &nbsp;&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template
                                v-for="item in reservations"
                                :key="item?.indentify"
                              >
                                <tr v-if="item">
                                  <td class="text-center">
                                    <div>
                                      <img
                                        :src="item?.photos[0]"
                                        style="height: 50px"
                                        class="img-thumbnail"
                                        alt="..."
                                      />
                                    </div>
                                  </td>
                                  <td class="text-secondary fs-6">
                                    #{{ item?.indentify }}
                                    <span class="d-block"
                                      >Via Porto {{ item?.name }}</span
                                    >
                                  </td>
                                  <td class="text-secondary fs-6">
                                    <span class="text-body">
                                      {{
                                        moment(item?.entryDate).format(
                                          "DD/MM/yyyy dddd"
                                        )
                                      }}
                                    </span>
                                  </td>
                                  <td class="text-secondary fs-6">
                                    <span class="text-body">
                                      {{
                                        moment(item?.departureDate).format(
                                          "DD/MM/yyyy dddd"
                                        )
                                      }}
                                    </span>
                                  </td>
                                  <td class="text-secondary fs-6">
                                    <span class="text-body">
                                      {{ item?.dates?.length }} Diárias</span
                                    >
                                    para
                                    <span class="text-body">
                                      {{ item?.totalPerson }} Hóspedis</span
                                    >
                                    <br />
                                    <span
                                      v-for="(person, index) in item?.person"
                                      :key="person"
                                    >
                                      {{ person }}
                                      {{
                                        index == 0
                                          ? "Adultos"
                                          : index == 1
                                          ? "Crianças"
                                          : "Bb´s"
                                      }}
                                      &nbsp;
                                    </span>
                                  </td>
                                  <td
                                    class="fs-6 complete"
                                    :class="item.status"
                                  >
                                    <span>
                                      {{ item.status }}
                                    </span>
                                    <select
                                      v-model="item.status"
                                      @change="setStatus(item.status, item)"
                                      class="form-select"
                                      aria-label="Status"
                                    >
                                      <option value="Realizado">
                                        Realizado
                                      </option>
                                      <option value="Cancelado">
                                        Cancelado
                                      </option>
                                      <option value="Pendente">Pendente</option>
                                    </select>
                                  </td>
                                  <td class="fs-6 text-end">
                                    {{ item.formOfPayment }} -
                                    {{
                                      item.total?.toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                      })
                                    }}
                                    &nbsp;&nbsp;
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Editar Dependente -->
        <div
          class="modal fade"
          ref="modalRefEditDependent"
          id="modalEditDependent"
          tabindex="-1"
          aria-labelledby="modalEditDependentLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="modalEditDependentLabel">Editar Dependente</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="editingDependent = null"
                ></button>
              </div>
              <div class="modal-body" v-if="editingDependent">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label>Nome:</label>
                    <input
                      v-model="editingDependent.name"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>E-mail:</label>
                    <input
                      v-model="editingDependent.email"
                      type="email"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>CPF:</label>
                    <input
                      v-model="editingDependent.cpf"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>RG:</label>
                    <input
                      v-model="editingDependent.rg"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Telefone:</label>
                    <input
                      v-model="editingDependent.phone"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Parentesco:</label>
                    <input
                      v-model="editingDependent.kinship"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Sexo:</label>
                    <select
                      v-model="editingDependent.sex"
                      class="form-control form-select"
                    >
                      <option value="Masculino">Masculino</option>
                      <option value="Feminino">Feminino</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Data de Nascimento:</label>
                    <input
                      v-model="editingDependent.date_birth"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Senha:</label>
                    <input
                      v-model="editingDependent.password"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                  @click="editingDependent = null"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="saveDependentEdit"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Depoimento -->
        <div
          class="modal fade"
          ref="modalRefDepoimento"
          id="modalDepoimento"
          tabindex="-1"
          aria-labelledby="modalDepoimentoLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="modalDepoimentoLabel">
                  Adicionar Depoimento
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="saveDepoimento">
                  <div class="mb-3">
                    <label class="form-label">Nome</label>
                    <input
                      v-model="formDataDepoimento.name"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Descrição</label>
                    <textarea
                      v-model="formDataDepoimento.description"
                      class="form-control"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Tipo de Vídeo</label>
                    <select
                      v-model="formDataDepoimento.videoType"
                      class="form-select"
                    >
                      <option value="youtube">YouTube</option>
                      <option value="upload">Upload de Vídeo</option>
                    </select>
                  </div>
                  <div
                    v-if="formDataDepoimento.videoType === 'youtube'"
                    class="mb-3"
                  >
                    <label class="form-label">ID do Vídeo do YouTube</label>
                    <input
                      v-model="formDataDepoimento.videoId"
                      type="text"
                      class="form-control"
                      placeholder="Ex: dQw4w9WgXcQ"
                      required
                    />
                  </div>
                  <div v-else class="mb-3">
                    <label class="form-label">Upload de Vídeo</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="video/*"
                      @change="handleVideoUpload"
                      :disabled="formDataDepoimento.isUploading"
                    />
                    <div
                      v-if="formDataDepoimento.isUploading"
                      class="progress mt-2"
                    >
                      <div
                        class="progress-bar"
                        role="progressbar"
                        :style="{
                          width: formDataDepoimento.uploadProgress + '%',
                        }"
                        :aria-valuenow="formDataDepoimento.uploadProgress"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {{ formDataDepoimento.uploadProgress }}%
                      </div>
                    </div>
                    <small
                      v-if="formDataDepoimento.isUploading"
                      class="text-muted"
                    >
                      Aguarde o upload do vídeo completar...
                    </small>
                    <small
                      v-else-if="formDataDepoimento.videoUrl"
                      class="text-success"
                    >
                      Vídeo carregado com sucesso!
                    </small>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      :disabled="
                        formDataDepoimento.isUploading ||
                        (formDataDepoimento.videoType === 'upload' &&
                          !formDataDepoimento.videoUrl)
                      "
                    >
                      {{
                        formDataDepoimento.isUploading ? "Aguarde..." : "Salvar"
                      }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { reactive, ref, onMounted, watch } from "vue";
import { accountStore } from "@/store/account.store";
import { storeToRefs } from "pinia";
import {
  fetchProfiles,
  fetchTitles,
  deleteHotelIndentify,
  deleteCupomIndentify,
  fetchInvites,
  fetchHotels,
  fetchCupons,
  CREAT_INVITE_MANUAL,
  CREAT_TITLE_MANUAL,
  UPDATE_TITLE,
  GET_HOTEL,
  GET_TITLE,
  DB_UPDATE_PROFILE,
  deleteTitle,
  deleteInvite,
  UPDATE_HOTELS,
  sendEmail,
  db,
  storage,
  deleteDependent,
} from "@/root/firebase";
import { adminStore } from "@/store/admin.store";
import AddHotel from "@/components/profile/AddHotel.vue";
import AddCupons from "@/components/profile/AddCupons.vue";
import AddParkTour from "@/components/profile/addParkTour.vue";
import AddParkClub from "@/components/profile/addParkAndClub.vue";
import { Modal } from "bootstrap";
import moment from "moment";
import "moment/locale/pt-br";
import { notify } from "@kyvg/vue3-notification";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  doc,
  setDoc,
  deleteDoc,
  collection,
  getDocs,
  addDoc,
  query,
  orderBy,
  serverTimestamp,
  getDoc,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

moment.locale("pt-br");

// Verificar se o db está disponível
console.log("Firebase db status:", !!db);

const { account } = storeToRefs(accountStore());
const { profiles } = storeToRefs(adminStore());
const email = ref("");
const code = ref("");
const title = ref("");
const titles = ref([]);
const invite = ref("");
const hotels = ref([]);
const cupons = ref([]);
const invites = ref([]);
const depoimentos = ref([]);
const hotelEdit = ref(null);
const hpEdit = ref(null);
const pcEdit = ref(null);
const cupomEdit = ref(null);
const modalRef = ref(null);
const modalRefHp = ref(null);
const modalRefPc = ref(null);
const modalRefCupom = ref(null);
const modalRefTitle = ref(null);
const modalRefInvite = ref(null);
const modalRefDepoimento = ref(null);
const modalRefEditDependent = ref(null);
const type = ref("");
const msgErrorTitle = ref("");
const reservations = ref([]);
const _profile = ref("");
const profileDetails = ref(null);
const clientDependents = ref([]);
const editingProfile = ref(false);
const editingDependent = ref(null);
const formDataTitle = reactive({
  plan: "ouro",
  plan_indentify: "",
  unlocked: false,
  uso: false,
  validy: true,
  new: true,
});
const formDataInvite = reactive({
  plan: "ouro",
  plan_indentify: "",
  unlocked: true,
  validy: true,
  new: true,
});
const formDataDepoimento = reactive({
  name: "",
  description: "",
  videoType: "youtube",
  videoId: "",
  videoUrl: "",
  indentify: "",
  uploadProgress: 0,
  isUploading: false,
});

// Adicionar watch para limpar os campos quando mudar o tipo
watch(
  () => formDataDepoimento.videoType,
  (newType) => {
    formDataDepoimento.videoId = "";
    formDataDepoimento.videoUrl = "";
    formDataDepoimento.uploadProgress = 0;
    formDataDepoimento.isUploading = false;
  }
);

const auth = getAuth();

const isMobile = ref(window.innerWidth <= 900);

const createTitle = async () => {
  if (!formDataTitle.plan_indentify) {
    notify({
      title: "Erro",
      text: "Precisa ter um código",
      type: "error",
      duration: 5000,
    });
    return;
  }
  try {
    await CREAT_TITLE_MANUAL(formDataTitle.plan_indentify, formDataTitle);
    Modal.getInstance(modalRefTitle.value)?.hide();
    titles.value.push(formDataTitle);
  } catch (error) {
    notify({
      title: "Erro",
      text: "Erro ao criar titulo",
      type: "error",
      duration: 5000,
    });
  }
};

const createInvite = async () => {
  if (!formDataInvite.plan_indentify) {
    notify({
      title: "Erro",
      text: "Precisa ter um código",
      type: "error",
      duration: 5000,
    });
    return;
  }
  try {
    await CREAT_INVITE_MANUAL(formDataInvite.plan_indentify, formDataInvite);
    Modal.getInstance(modalRefInvite.value)?.hide();
    invites.value.push(formDataInvite);
  } catch (error) {
    notify({
      title: "Erro",
      text: "Erro ao criar convite",
      type: "error",
      duration: 5000,
    });
  }
};

const getReservations = async (p, re) => {
  _profile.value = p;
  profileDetails.value = p;

  reservations.value = [];
  if (re) {
    reservations.value = re;
  }
  
  // Buscar dependentes do cliente (sempre busca, independente de ser titular ou não)
  // Se for titular (dep = false ou não existe), busca dependentes com mesmo plan_indentify
  // Se for dependente (dep = true), também pode ter dependentes (caso especial)
  if (p?.plan_indentify) {
    await fetchClientDependents(p.plan_indentify, p.indentify);
  } else {
    clientDependents.value = [];
  }
};

const setUso = (title) => {
  title.uso = true;
  UPDATE_TITLE(title.plan_indentify, title);
};

const closed = (ref) => {
  if (ref == "cupom") {
    cupomEdit.value = null;
    Modal.getInstance(modalRefCupom.value)?.hide();
    return;
  }
  if (ref == "hp") {
    hpEdit.value = null;
    Modal.getInstance(modalRefHp.value)?.hide();
    return;
  }
  if (ref == "pc") {
    pcEdit.value = null;
    Modal.getInstance(modalRefPc.value)?.hide();
    return;
  }
  if (ref == "title") {
    pcEdit.value = null;
    Modal.getInstance(modalRefTitle.value)?.hide();
    return;
  }
  if (ref == "invite") {
    pcEdit.value = null;
    Modal.getInstance(modalRefInvite.value)?.hide();
    return;
  }
  hotelEdit.value = null;
  Modal.getInstance(modalRef.value)?.hide();
};

const unlocked = (title, bol) => {
  title.unlocked = bol;
  UPDATE_TITLE(title.plan_indentify, title);
};

const addTitle = (title, profile) => {
  GET_TITLE(title).then((_title) => {
    const titleData = _title.data();
    if (titleData?.validy && !titleData?.unlocked) {
      profile.plan = titleData.plan;
      profile.plan_indentify = titleData?.plan_indentify;
      profile.plan_unlocked = titleData?.unlocked;
      profile.plan_valid = titleData?.validy;

      DB_UPDATE_PROFILE(profile.indentify, profile);
      msgErrorTitle.value = "";
      profile.tt = "";
    } else {
      msgErrorTitle.value = profile.indentify;
    }
  });
};

const setStatus = async (status, reserva) => {
  const { dates, hotel_indentify } = reserva || {};

  if (!dates || !hotel_indentify) return;

  const hotel = await GET_HOTEL(reserva.hotel_indentify);
  const blocked_dates = hotel.data().blocked_dates || [];
  blocked_dates.push(...dates);

  _profile.value.reservations = _profile.value.reservations.map((el) => {
    if (reserva.indentify == el.indentify) el.status = status;
    return el;
  });

  DB_UPDATE_PROFILE(_profile.value.indentify, _profile.value);

  const to_email = profileDetails.value?.email;
  const to_name = profileDetails.value?.name;
  const total = reserva?.total.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  const message = `Sua reserva ${reserva?.name} em ${reserva?.city} - ${
    reserva.state
  } no valor de ${total}
  para ${
    reserva?.totalPerson > 1
      ? reserva?.totalPerson + " pessoas"
      : reserva?.totalPerson + " pessoa"
  }
  teve um status alterado para: ${status}
  `;

  const emailData = {
    to_name,
    message,
    to_email,
  };

  sendEmail(emailData);

  if (status == "Realizado")
    UPDATE_HOTELS(reserva.hotel_indentify, { blocked_dates: blocked_dates });
};

const listProfiles = async (emailSearch, codeSearch) => {
  if (!account.value.admin) return;

  let profile;
  
  if (codeSearch && codeSearch.trim()) {
    // Buscar por código
    profile = await fetchProfilesByCode(codeSearch.trim());
  } else {
    // Buscar por email ou listar todos
    profile = await fetchProfiles(emailSearch);
  }

  profiles.value = [];

  profile.forEach((doc) => {
    profiles.value.push(doc.data());
  });
};

// Função para buscar perfis por código
const fetchProfilesByCode = async (code) => {
  const q = query(
    collection(db, "profiles"),
    where("plan_indentify", "==", code)
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot;
};

// Função para buscar dependentes de um cliente
const fetchClientDependents = async (planIndentify, currentProfileId) => {
  if (!planIndentify) {
    clientDependents.value = [];
    return;
  }
  
  try {
    // Busca todos os perfis com o mesmo plan_indentify que sejam dependentes
    // e que não sejam o próprio perfil atual
    const q = query(
      collection(db, "profiles"),
      where("plan_indentify", "==", planIndentify),
      where("dep", "==", true)
    );
    const querySnapshot = await getDocs(q);
    clientDependents.value = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      // Filtra para não incluir o próprio perfil se for dependente
      if (!currentProfileId || data.indentify !== currentProfileId) {
        clientDependents.value.push(data);
      }
    });
    console.log(`[DEBUG] Dependentes encontrados: ${clientDependents.value.length} para código ${planIndentify}`);
  } catch (error) {
    console.error("Erro ao buscar dependentes:", error);
    clientDependents.value = [];
  }
};

// Função para salvar edição do perfil
const saveProfileEdit = async () => {
  if (!profileDetails.value) return;
  
  try {
    await DB_UPDATE_PROFILE(profileDetails.value.indentify, profileDetails.value);
    notify({
      title: "Sucesso",
      text: "Perfil atualizado com sucesso!",
      type: "success",
      duration: 3000,
    });
    editingProfile.value = false;
    // Atualiza a lista de perfis
    await listProfiles(email.value, code.value);
  } catch (error) {
    notify({
      title: "Erro",
      text: "Erro ao atualizar perfil",
      type: "error",
      duration: 5000,
    });
  }
};

// Função para editar dependente
const editDependent = (dependent) => {
  editingDependent.value = { ...dependent };
};

// Função para salvar edição do dependente
const saveDependentEdit = async () => {
  if (!editingDependent.value) return;
  
  try {
    await DB_UPDATE_PROFILE(editingDependent.value.indentify, editingDependent.value);
    notify({
      title: "Sucesso",
      text: "Dependente atualizado com sucesso!",
      type: "success",
      duration: 3000,
    });
    // Atualiza a lista de dependentes
    await fetchClientDependents(profileDetails.value?.plan_indentify, profileDetails.value?.indentify);
    editingDependent.value = null;
    const modal = Modal.getInstance(modalRefEditDependent.value);
    if (modal) modal.hide();
  } catch (error) {
    notify({
      title: "Erro",
      text: "Erro ao atualizar dependente",
      type: "error",
      duration: 5000,
    });
  }
};

// Função para excluir dependente
const deleteClientDependent = async (dependent) => {
  if (!window.confirm(`Tem certeza que deseja excluir o dependente ${dependent.name}?`)) {
    return;
  }
  
  try {
    await deleteDependent(dependent.indentify);
    notify({
      title: "Sucesso",
      text: "Dependente excluído com sucesso!",
      type: "success",
      duration: 3000,
    });
    // Atualiza a lista de dependentes
    await fetchClientDependents(profileDetails.value?.plan_indentify, profileDetails.value?.indentify);
  } catch (error) {
    notify({
      title: "Erro",
      text: "Erro ao excluir dependente",
      type: "error",
      duration: 5000,
    });
  }
};

const listTitles = async (title, type) => {
  if (!account.value.admin) return;
  const _title = await fetchTitles(title, type);

  titles.value = [];

  _title.forEach((doc) => {
    titles.value.push(doc.data());
  });
};

const listInvite = async (title, type) => {
  if (!account.value.admin) return;

  const p = await fetchInvites(title, type);
  invites.value = [];

  p.forEach((doc) => {
    invites.value.push(doc.data());
  });
};

const _deleteTitle = async (id) => {
  const userConfirmed = window.confirm(
    "Tem certeza de que deseja deletar este título?"
  );

  if (!userConfirmed) {
    return;
  }

  try {
    await deleteTitle(id);
    titles.value = titles.value.filter((title) => title.plan_indentify !== id);
  } catch (err) {
    notify({
      title: "Erro ao deletar",
      text: err,
      type: "error",
      duration: 7000,
    });
  }
};

const _deleteInvite = async (id) => {
  const userConfirmed = window.confirm(
    "Tem certeza de que deseja deletar este convite?"
  );

  if (!userConfirmed) {
    return;
  }

  try {
    await deleteInvite(id);
    invites.value = invites.value.filter(
      (title) => title.plan_indentify !== id
    );
  } catch (err) {
    notify({
      title: "Erro ao deletar",
      text: err,
      type: "error",
      duration: 7000,
    });
  }
};

const listHotel = async () => {
  const p = await fetchHotels();
  hotels.value = [];
  p.forEach((doc) => {
    hotels.value.push(doc.data());
  });
};

const listCupons = async () => {
  const p = await fetchCupons();
  cupons.value = [];
  p.forEach((doc) => {
    cupons.value.push(doc.data());
  });
};

const setHotel = (hotel) => {
  if (!hotel) {
    hotelEdit.value = null;
    return;
  }

  if (hotelEdit.value) {
    hotels.value = hotels.value.map((hh) => {
      if (hh.indentify === hotel.indentify) hh = hotel;
      return hh;
    });
  } else hotels.value.push(hotel);
  hotelEdit.value = null;
};

const setHp = (hotel) => {
  if (!hotel) {
    hpEdit.value = null;
    return;
  }

  if (hpEdit.value) {
    hotels.value = hotels.value.map((hh) => {
      if (hh.indentify === hotel.indentify) hh = hotel;
      return hh;
    });
  } else hotels.value.push(hotel);
  hpEdit.value = null;
};

const setPc = (hotel) => {
  if (!hotel) {
    cpEdit.value = null;
    return;
  }

  if (cpEdit.value) {
    hotels.value = hotels.value.map((hh) => {
      if (hh.indentify === hotel.indentify) hh = hotel;
      return hh;
    });
  } else hotels.value.push(hotel);
  cpEdit.value = null;
};

const setCupom = (cupom) => {
  if (!cupom) {
    cupomEdit.value = null;
    return;
  }

  if (cupomEdit.value) {
    cupons.value = cupons.value.map((hh) => {
      if (hh.indentify === cupom.indentify) hh = cupom;
      return hh;
    });
  } else cupons.value.push(cupom);
  cupomEdit.value = null;
};

const editHotel = (hotel) => {
  hotelEdit.value = hotel;
};

const editHp = (hotel) => {
  hpEdit.value = hotel;
};

const editPc = (hotel) => {
  pcEdit.value = hotel;
};

const editCupom = (cupom) => {
  cupomEdit.value = cupom;
};

const deleteHotel = async (id) => {
  const userConfirmed = window.confirm(
    "Tem certeza de que deseja deletar este hotel?"
  );

  if (!userConfirmed) {
    return;
  }

  try {
    await deleteHotelIndentify(id);
    hotels.value = hotels.value.filter((hotel) => hotel.indentify !== id);
  } catch (err) {
    notify({
      title: "Erro ao deletar",
      text: err,
      type: "error",
      duration: 7000,
    });
  }
};

const deleteCupom = async (id) => {
  const userConfirmed = window.confirm(
    "Tem certeza de que deseja deletar este cupom?"
  );

  if (!userConfirmed) {
    return;
  }

  try {
    await deleteCupomIndentify(id);
    cupons.value = cupons.value.filter((cupom) => cupom.indentify !== id);
  } catch (err) {
    notify({
      title: "Erro ao deletar",
      text: err,
      type: "error",
      duration: 7000,
    });
  }
};

const handleVideoUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  try {
    console.log("Iniciando upload do vídeo:", file.name);
    formDataDepoimento.isUploading = true;
    formDataDepoimento.uploadProgress = 0;

    const storageReference = storageRef(
      storage,
      `depoimentos/${Date.now()}_${file.name}`
    );
    const uploadTask = uploadBytesResumable(storageReference, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        formDataDepoimento.uploadProgress = Math.round(progress);
        console.log("Progresso do upload:", progress + "%");
      },
      (error) => {
        console.error("Erro no upload:", error);
        formDataDepoimento.isUploading = false;
        formDataDepoimento.uploadProgress = 0;
        notify({
          title: "Erro",
          text: `Erro ao fazer upload do vídeo: ${error.message}`,
          type: "error",
          duration: 5000,
        });
      },
      async () => {
        try {
          console.log("Upload completo, obtendo URL...");
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          console.log("URL do vídeo obtida:", downloadURL);

          formDataDepoimento.videoUrl = downloadURL;
          formDataDepoimento.isUploading = false;

          notify({
            title: "Sucesso",
            text: "Vídeo enviado com sucesso!",
            type: "success",
            duration: 3000,
          });
        } catch (urlError) {
          console.error("Erro ao obter URL:", urlError);
          formDataDepoimento.isUploading = false;
          formDataDepoimento.uploadProgress = 0;
          notify({
            title: "Erro",
            text: "Erro ao obter URL do vídeo",
            type: "error",
            duration: 5000,
          });
        }
      }
    );
  } catch (error) {
    console.error("Erro ao iniciar upload:", error);
    formDataDepoimento.isUploading = false;
    formDataDepoimento.uploadProgress = 0;
    notify({
      title: "Erro",
      text: `Erro ao iniciar upload do vídeo: ${error.message}`,
      type: "error",
      duration: 5000,
    });
  }
};

const saveDepoimento = async () => {
  try {
    // Verifica autenticação e permissões básicas
    const currentUser = auth.currentUser;
    console.log("Verificando autenticação:", {
      currentUser: !!currentUser,
      uid: currentUser?.uid,
      email: currentUser?.email,
      isAdmin: account.value?.admin,
    });

    if (!currentUser) {
      throw new Error("Usuário não está autenticado");
    }

    if (!account.value?.admin) {
      throw new Error("Usuário não tem permissões de administrador");
    }

    // Validações básicas
    if (!formDataDepoimento.name || !formDataDepoimento.description) {
      notify({
        title: "Erro",
        text: "Nome e descrição são obrigatórios",
        type: "error",
        duration: 5000,
      });
      return;
    }

    if (
      formDataDepoimento.videoType === "youtube" &&
      !formDataDepoimento.videoId
    ) {
      notify({
        title: "Erro",
        text: "ID do vídeo do YouTube é obrigatório",
        type: "error",
        duration: 5000,
      });
      return;
    }

    if (
      formDataDepoimento.videoType === "upload" &&
      !formDataDepoimento.videoUrl
    ) {
      notify({
        title: "Erro",
        text: "Por favor, aguarde o upload do vídeo completar",
        type: "error",
        duration: 5000,
      });
      return;
    }

    // Gera um ID único para o documento
    const docId = Date.now().toString();

    // Prepara os dados
    const depoimentoData = {
      name: formDataDepoimento.name,
      description: formDataDepoimento.description,
      video_type: formDataDepoimento.videoType,
      video_id:
        formDataDepoimento.videoType === "youtube"
          ? formDataDepoimento.videoId
          : null,
      video_url:
        formDataDepoimento.videoType === "upload"
          ? formDataDepoimento.videoUrl
          : null,
      created_at: serverTimestamp(),
      active: true,
      created_by: {
        uid: currentUser.uid,
        email: currentUser.email,
      },
    };

    console.log("Dados do depoimento a ser salvo:", depoimentoData);

    // Verifica se o db está disponível
    if (!db) {
      throw new Error("Conexão com o Firestore não está disponível");
    }

    // Salva no Firestore
    const depoimentoRef = doc(db, "testimonies", docId);
    await setDoc(depoimentoRef, depoimentoData);
    console.log("Documento criado com sucesso. ID:", docId);

    // Atualiza a lista local
    depoimentoData.id = docId;
    depoimentoData.created_at = new Date().toISOString();
    depoimentos.value.push(depoimentoData);

    // Fecha o modal e limpa o formulário
    const modalInstance = Modal.getInstance(modalRefDepoimento.value);
    if (modalInstance) {
      modalInstance.hide();
    }

    // Limpa o formulário
    formDataDepoimento.name = "";
    formDataDepoimento.description = "";
    formDataDepoimento.videoId = "";
    formDataDepoimento.videoUrl = "";
    formDataDepoimento.videoType = "youtube";

    notify({
      title: "Sucesso",
      text: "Depoimento salvo com sucesso",
      type: "success",
      duration: 5000,
    });

    // Recarrega a lista
    await listDepoimentos();
  } catch (error) {
    console.error("Erro detalhado ao salvar depoimento:", {
      error: {
        name: error.name,
        message: error.message,
        code: error.code,
        stack: error.stack,
      },
      authStatus: {
        isAuthenticated: !!auth.currentUser,
        uid: auth.currentUser?.uid,
        email: auth.currentUser?.email,
        isAdmin: account.value?.admin,
      },
    });

    notify({
      title: "Erro",
      text: `Erro ao salvar depoimento: ${error.message}`,
      type: "error",
      duration: 5000,
    });
  }
};

const listDepoimentos = async () => {
  try {
    const depoimentosRef = collection(db, "testimonies");
    const q = query(depoimentosRef, orderBy("created_at", "desc"));
    const depoimentosSnapshot = await getDocs(q);

    depoimentos.value = [];

    depoimentosSnapshot.forEach((doc) => {
      depoimentos.value.push({
        id: doc.id,
        ...doc.data(),
      });
    });
  } catch (error) {
    console.error("Erro ao carregar depoimentos:", error);
    depoimentos.value = [];
  }
};

const deleteDepoimento = async (id) => {
  const userConfirmed = window.confirm(
    "Tem certeza de que deseja deletar este depoimento?"
  );

  if (!userConfirmed) {
    return;
  }

  try {
    await deleteDoc(doc(db, "testimonies", id));
    depoimentos.value = depoimentos.value.filter(
      (depoimento) => depoimento.id !== id
    );
    notify({
      title: "Sucesso",
      text: "Depoimento deletado com sucesso",
      type: "success",
      duration: 5000,
    });
  } catch (error) {
    console.error("Erro ao deletar depoimento:", error);
    notify({
      title: "Erro",
      text: "Erro ao deletar depoimento",
      type: "error",
      duration: 5000,
    });
  }
};

const openDepoimentoModal = () => {
  // Limpa o formulário antes de abrir
  Object.keys(formDataDepoimento).forEach((key) => {
    formDataDepoimento[key] = "";
  });
  formDataDepoimento.videoType = "youtube";

  // Abre o modal
  const modal = new Modal(modalRefDepoimento.value);

  // Adiciona evento para quando o modal for completamente fechado
  modalRefDepoimento.value.addEventListener("hidden.bs.modal", () => {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  });

  modal.show();
};

onMounted(() => {
  listProfiles();
  listTitles();
  listInvite();
  listHotel();
  listCupons();
  listDepoimentos();
});
</script>

<style scoped>
tr,
th {
  text-align: left;
}
td {
  font-size: 0.9rem !important;
  text-align: left;
}

.Pendente {
  color: #686868 !important;
}
.Realizado {
  color: #14a36c !important;
}
.Cancelado {
  color: #b91b1b !important;
}
.expand-contanct {
  cursor: pointer;
  z-index: 99;
  color: #333;
  position: absolute;
  right: 0rem;
  top: 0.5rem;
  width: 2rem;
  height: 2rem;
}
</style>
